import gql from "graphql-tag";

//--------
// QUERIES
//--------

export const currentUserQuery = gql`
  query currentUserQuery {
    currentUserContext {
      uid
      status
      roles {
        targetId
      }
      ... on User {
        name
        mail
        fieldVatNumber
        fieldMainBusinessArea {
          entity {
            entityLabel
          }
        }
        fieldCompanyName
        fieldBasketReference {
          entity {
            ... on NodeBasket {
              fieldBasketTotalAmount
              fieldIsDabBudget
              fieldIsDTrainingBudget
              fieldBasketCoBranding
              fieldBasketAmount
              fieldIsBusinessAreaBudget
            }
          }
        }
        fieldAddress {
          locality
        }
        fieldRegion {
          targetId
          entity {
            ... on TaxonomyTermDistributionRegions {
              entityLabel
              fieldDocumentationPercentage
              fieldOthersPercentage
            }
          }
        }
      }
    }
  }
`;

export const availableLanguages = gql`
  query availableLanguages($vid: String!, $lang: String!) {
    taxonomygenericviewGraphql1View(filter: { vid: $vid, langcode: $lang }) {
      results {
        name
        tid
      }
    }
  }
`;

export const availableSiteLanguages = gql`
  query availableLanguages {
    availableLanguages {
      name
      id
      isDefault
    }
  }
`;

export const availableCurrencies = gql`
  query availableCurrencies($lang: [String!]) {
    nodeQuery(filter: { conditions: [{ field: "type", value: "currency" }, {field: "langcode", value: $lang}] }) {
      entities {
        ... on NodeCurrency {
          title
          nid
          fieldCurrencySign
          fieldCurrencyName
        }
      }
    }
  }
`;

export const countriesQuery = gql`
  query countriesQuery($lang: String!) {
    countriesListGraphql1View(filter: { langcode: $lang }) {
      results {
        ... on TaxonomyTermCountries {
          tid
          name
        }
      }
    }
  }
`;

export const businessAreasQuery = gql`
  query businessAreasQuery($lang: String!) {
    businessAreasGraphql1View(filter: { langcode: $lang }) {
      results {
        ... on TaxonomyTermBusinessAreas {
          tid
          name
        }
      }
    }
  }
`;

//----------
// MUTATIONS
//----------

export const updateUserAfterRegistration = gql`
  mutation updateUserAfterRegistration(
    $id: String!
    $fieldVatNumber: String!
    $fieldCompanyName: String
    $fieldMainBusinessArea: String!
    $countryCode: String!
    $addressLine1: String!
    $locality: String!
    $givenName: String!
    $familyName: String!
  ) {
    updateUser(
      id: $id
      input: {
        fieldVatNumber: $fieldVatNumber
        fieldCompanyName: $fieldCompanyName
        fieldMainBusinessArea: { targetId: $fieldMainBusinessArea }
        fieldAddress: {
          countryCode: $countryCode
          addressLine1: $addressLine1
          locality: $locality
          givenName: $givenName
          familyName: $familyName
        }
      }
    ) {
      entity {
        ... on User {
          uid
          status
          roles {
            targetId
          }
          name
          mail
          fieldVatNumber
          fieldMainBusinessArea {
            entity {
              entityLabel
            }
          }
          fieldCompanyName
          fieldBasketReference {
            entity {
              ... on NodeBasket {
                fieldBasketTotalAmount
                fieldIsDabBudget
                fieldIsDTrainingBudget
                fieldBasketCoBranding
                fieldBasketAmount
                fieldIsBusinessAreaBudget
              }
            }
          }
          fieldAddress {
            locality
          }
        }
      }
      errors
      violations {
        message
        path
        code
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/login.js